import { useEffect, useRef } from 'react';

const useBroadcastChannel = (channelName, messageHandler) => {
  if (channelName === undefined) {
    throw Error('useBroadcastChannel requires channelName param');
  }

  let channel = useRef(new BroadcastChannel(channelName));
  const appliedHandler = messageHandler(channel.current);

  const postMessage = message => {
    channel.current.postMessage(message);
  };

  useEffect(() => {
    if (channel && channel.current) {
      channel.current.onmessage = e => appliedHandler(e);
    }

    return () => {
      if (channel && channel.current) {
        channel.current.close();
        channel.current = null;
      }
    };
  }, [channelName]);

  return [postMessage];
};

export default useBroadcastChannel;
